// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type ConnectGcsToSiteMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  config: Types.GcsConnectionInput;
}>;


export type ConnectGcsToSiteMutation = (
  { __typename?: 'Mutation' }
  & { connectGCSToSite?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message' | 'errorType'>
  )> }
);


export const ConnectGcsToSiteDocument = gql`
    mutation connectGCSToSite($siteId: UUID!, $config: GCSConnectionInput!) {
  connectGCSToSite(siteId: $siteId, config: $config) {
    success
    message
    errorType
  }
}
    `;
export type ConnectGcsToSiteMutationFn = ApolloReactCommon.MutationFunction<ConnectGcsToSiteMutation, ConnectGcsToSiteMutationVariables>;

/**
 * __useConnectGcsToSiteMutation__
 *
 * To run a mutation, you first call `useConnectGcsToSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectGcsToSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectGcsToSiteMutation, { data, loading, error }] = useConnectGcsToSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useConnectGcsToSiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConnectGcsToSiteMutation, ConnectGcsToSiteMutationVariables>) {
        return ApolloReactHooks.useMutation<ConnectGcsToSiteMutation, ConnectGcsToSiteMutationVariables>(ConnectGcsToSiteDocument, baseOptions);
      }
export type ConnectGcsToSiteMutationHookResult = ReturnType<typeof useConnectGcsToSiteMutation>;
export type ConnectGcsToSiteMutationResult = ApolloReactCommon.MutationResult<ConnectGcsToSiteMutation>;
export type ConnectGcsToSiteMutationOptions = ApolloReactCommon.BaseMutationOptions<ConnectGcsToSiteMutation, ConnectGcsToSiteMutationVariables>;
